import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Pagination from "../../../../module/pagination";
import moment from "moment";
import {alertActions, authActions, contracterActions, inboxActions , modalActions} from '../../../../store/actions'
import history from "../../../../route/history";
import Scroll from '../../../../hook/scroll'
import {commons} from "../../../../hook/common";

import CerficateReceiverModal from '../modal/CerficateReceiverModal'; //증명서 제출팝업

const CertificateInboxList = props => {

  const [checkedContacts, setCheckedContacts] = useState(new Set());
  const checkedContactsRef = useRef(checkedContacts)
  
  const[canSubmit, setCanSubmit] = useState(false)  //제출버튼 표시 여부
  const[canAccept, setCanAccept] = useState(false)  //수취 버튼 표시 여부
  const[canReject, setCanReject] = useState(false)  //반려 버튼 표시 여부
  const[canDelete, setCanDelete] = useState(false)  //삭제 버튼 표시 여부

  const canShowEdit = useRef((() =>
    {return (checkedContactsRef.current.size && (canSubmit || canAccept || canReject || canDelete))})
  );
 

  const [showEdit, setShowEdit] = useState();  //퍼블리싱임시: 체크선택시 옵션기능보여줌 06.23
  
  const [contAllCheck, setContAllCheck] = useState(false);
 
  const tabIdRef = useRef()
  useEffect(() => {
    if(props.tabId !== tabIdRef.current) {
      tabIdRef.current = props.tabId
      setCheckedContacts(new Set())
      checkedContactsRef.current.clear()
      setContAllCheck(false)
      setShowEdit(false)
    }
  }, [props.tabId]);

  useEffect(() => {
    if (props.isSubmit) {
      handleAllCheck(false);
    }
  }, [props.isSubmit]);
  // useEffect(() => {
  //   let checkedItem = document.querySelector('input[name="row-popover"]:checked');

  //   if (checkedItem) checkedItem.checked = false;

  // }, [props.data]);

  useEffect(() => {
    let type = "";
    if (props.isDelete || props.isDelete2) { // 수신함 삭제 성공
      type = "삭제";
    } else if (props.isReject) { // 수신함 반려신청 성공
      type = "반려";
    } else if (props.isReceive) { // 수취완료 성공
      // type = "수취완료";
      type = "읽음";
    } else {
      return; // 에러처리 전까진 그냥 리턴시킴
    }

    props.success({
      title: type + '성공',
      message: type + '되었습니다.',
      params: {
        type: 'success',
        callback: () => {
          window.location.reload();
          // props.readInboxList();
        }
      }
    })
  }, [props.isDelete, props.isDelete2, props.isReject, props.isReceive]);

  useEffect(() => {
    const fileList = props.inboxInfo?.fileList;

    if (!fileList) {
      //props.error({message: 'PDF 파일이 존재하지 않습니다.'});
      return;
    }

    //commons.openPdf(fileList[0].fileId);
  }, [props.inboxInfo]);



  const makeStatusBtn = (status) => {
    switch (status) {
      case '03':
        return (<span className="badge btn-blue">발급완료</span>);
        break;
      case '01':
        return (<span className="badge btn-dark-gray">임시저장</span>);
        break;
      case '02':
        return (<span className="badge  btn-purple">전송완료</span>);
        break;
      case '04':
        return (<span className="badge btn-danger">오류통보</span>);
        break;
      case '10':
        // return (<span className="badge btn-danger">제출</span>);
        return (<span className="badge btn-danger">안 읽음</span>);
        break;
      case '11':
        return (<span className="badge btn-warning">반려</span>);
        break;
      case '12':
        // return (<span className="badge  btn-success">수취완료</span>);
        return (<span className="badge  btn-success">읽음</span>);
        break;
      default:
        return (<span className="badge badge-border">상태미정{status}</span>);
    }
  }
  

  const onInboxSubmit = () => {
    props.onInboxSubmit(Array.from(checkedContactsRef.current));
  };

  
  const getChecked = () => {
    let checkedCrtSeqSet = new Set()
    let checkedRcvCrtSeqSet = new Set()
    for(let obj of checkedContactsRef.current) {
      checkedCrtSeqSet.add(obj.crtSeq)
      checkedRcvCrtSeqSet.add(obj.crtRcvSeq)
    }
    let checkedCrtSeqArr = Array.from(checkedCrtSeqSet)
    let checkedRcvCrtSeqArr = Array.from(checkedRcvCrtSeqSet)
    return {
      checkedCrtSeq: checkedCrtSeqArr,
      checkedRcvCrtSeq: checkedRcvCrtSeqArr
    }
  }


  //const onDelete = (contract) => {
  const onDelete = () => {
    // 1. 유효성 체크: 삭제가 가능한건 임시저장(01), 오류통보(04), 발급완료(03), 수취완료(읽음)(12)의 경우에만

    //FIXME 일단 오류 안 나게 하나만 끌어내서 하는 걸로 바꿔 놓음. 수정해야 함.
    let contract = checkedContactsRef.current.pop()

    



    if (contract.sts === "01" || contract.sts === "04") { // 임시저장과 오류통보 삭제시
      props.confirm({
        title: '확인',
        message: '증명서를 삭제하시겠습니까?',
        params: {
          type: 'confirm',
          callback: () => {
            props.deleteTempDoc(contract.crtSeq);
          }
        }
      })
    } else {
      let checked = getChecked();
      props.confirm({
        title: '확인',
        message: '증명서를 삭제하시겠습니까?',
        params: {
          type: 'confirm',
          callback: () => {
            const params = {
              crtSeqList : checked.checkedCrtSeq,
              crtRcvSeqList: checked.checkedRcvCrtSeq,
              type: 'receive'
            }
            props.deleteInbox(params);

          }
        }
      })
    }
    
  }

  const onReject = () => {
    // 증명서 반려
    let checked = getChecked();
    props.confirm({
      title: '확인',
      message: '증명서를 반려하시겠습니까?',
      params: {
        type: 'confirm',
        callback: () => {
          const params = {
            crtSeqList : checked.checkedCrtSeq
          }
          props.rejectInbox(params);
        }
      }
    })
  }

  const onReceive = () => {
    let checked = getChecked();
    props.confirm({
      title: '확인',
      // message: '증명서를 수취완료하시겠습니까?',
      message: '증명서를 읽은 상태로 변경하시겠습니까?',
      params: {
        type: 'confirm',
        callback: () => {
          const params = {
            crtSeqList : checked.checkedCrtSeq
          }
          props.receiveInbox(params);
        }
      }
    })
  }

  // 조건 단건 변경시
  const onSelected = (e, type, value) => {
    let changedObj = {
      type: type,
      value: value
    };
    props.changeSearchInfo(changedObj);
  }


  /**
   * pdf download
   * //TODO someday 상위 컴퍼넌트로 끌어올릴 것
   */
  let onPdfDown = (contract) => {
    console.log('contract', contract)
    console.log('props', props)

    let fileList = [];
    if(contract?.fileList || contract?.attachList) {
      fileList = [ ...contract?.fileList || [], ...contract?.attachList|| [] ]
    }
    if (!fileList || ! fileList.length) {
      props.error({message: 'PDF 파일이 존재하지 않습니다.'});
      return;
    }
    
    fileList.forEach((val, idx, arr) => {
      setTimeout(() => {
        let url = process.env.REACT_APP_API_URL + '/portal/file/general/'+ fileList[idx].encryptedId
        let xhr = new XMLHttpRequest();
        xhr.responseType = 'blob';
        xhr.onload = function () {
          let _anchor = document.createElement('a');
          _anchor.href = window.URL.createObjectURL(xhr.response); // xhr.response is a blob
          _anchor.download = val['originFileNm']; // Set the file name.
          _anchor.style.display = 'none';
          document.body.appendChild(_anchor);
          _anchor.click();
          document.body.removeChild(_anchor);
        };
        xhr.open('GET', url);
        xhr.send();
      }, 20);  
    })
  }

  
  /**
   * @param {String} stsCd 
   * @returns 선택된 계약 중에 해당 sts 인 것이 존재하는지 여부
   */
   let hasChecked = (stsCd) => {
    for(let obj of checkedContactsRef.current) {
      if(obj.sts === stsCd) {
        return true
      }        
      return false
    }
  }

  /**   * 
   * @param {Array} stsCdArr 
   * @returns 일치하는 거 하나라도 선택되었으면 true
   */
  let hasAnyChecked = (stsCdArr) => {
    for(let obj of checkedContactsRef.current) {
      if(stsCdArr.includes(obj.sts)) {
        return true
      }        
    }   
    return false
  }

  /**
   * @param {Array} stsCdArr 
   * @returns 일치하는 거 하나라도 선택되었으면 false
   */
  let hasNoneChecked = (stsCdArr) => {
    for(let obj of checkedContactsRef.current) {
      if(stsCdArr.includes(obj.sts)) {        
        return false
      }
    }   
    return true
  }

  const stsLiteral = {
    임시저장: '01',
    전송완료: '02',
    발급완료: '03',
    오류통보: '04',

    제출: '10',
    반려: '11',
    수취완료: '12',
    회수: '13'
  }

  //복수 제어 함수
  const changeShowForm = () => {

    setShowEdit(checkedContactsRef.current.size);
    const sts = stsLiteral

    //제출버튼 표시할 지 여부
    let bShowSubmit = false;
    bShowSubmit = hasChecked(sts.발급완료)  //발급완료 상태가 포함
    // 다음 건들이 선택되었을 경우 표시 안 함
    // 임시저장, 전송완료는 발급완료 전단계로 생각됨. 
    // 제출, 수취완료 건은 중복 제출을 막음. 
    // 오류통보, 반려, 회수 건은 수정해서 다시 제출하는 게 맞을 거라 생각됨
    bShowSubmit = bShowSubmit && hasNoneChecked([sts.임시저장, sts.전송완료, sts.제출, sts.수취완료])
    console.log(`bShowSubmit:${bShowSubmit}`)
    setCanSubmit(bShowSubmit);

    //수취 버튼 표시할지 여부
    let bShowAccept = false;
    bShowAccept = hasChecked(sts.제출)
    setCanAccept(bShowAccept)
    
    //반려 버튼 표시할지 여부
    let bShowReject = false
    bShowReject = hasChecked(sts.제출)
    setCanReject(bShowReject)    
  };

  const handleAllCheck = (target, checked) => {
    setContAllCheck(checked);
    if(checked) {
      props.data.forEach(item => checkedContactsRef.current.add(item))
    } else {
      checkedContactsRef.current.clear()
    }
    setCheckedContacts(checkedContactsRef.current)
    changeShowForm();
  };  

  const checkedItemHandler = (id, isChecked, crtSeq, sts, crtRcvSeq, obj) => {
    
    if(isChecked) {
      checkedContactsRef.current.add(obj)
    } else {
      for(let cont of checkedContactsRef.current) {
        if(obj === cont) {
          checkedContactsRef.current.delete(cont)
        }
      }  
    }
    setCheckedContacts(checkedContactsRef.current)
    changeShowForm();
  };

  const checkHandler = ({target}, contract) => {
    checkedItemHandler(target.id, target.checked, contract.crtSeq, contract.sts, contract.crtRcvSeq, contract);
  };

  return (
    <>
      {/* Edit Option */}
      {/* DEV: Header 와 만나면 fix-top  추가  */}
      {/* <div className={`editlist-box ${canShowEdit ? "select-active" : " " }`} >   */}
      <div className={`editlist-box ${showEdit ? "select-active" : " " }`} >  

       <div className="edit-content">
          <div className="edit-head">
              {/* <span className="cnt"><span className="blind"> 선택됨</span><span>{checkedItems.size}</span></span> */}
              <span className="cnt"><span className="blind"> 선택됨</span><span>{checkedContacts.size}</span></span>
              <span className="slash">/</span>
              <span className="total"><span className="blind">전체</span><span>{props.data?.length}</span></span>
              <button className="bt_close_wh" onClick={(e) => handleAllCheck(e.target, false)}><span aria-hidden="true">선택창 닫기</span> </button>
          </div>
          <div className="btn-group">
              {/* stat은  안읽음, action은 제출/ stat 은 읽음, action 은 수취완료 */}
              <button className="btn-select" onClick={(e) => handleAllCheck(e.target, ! contAllCheck)}><span>전체선택</span></button>
              <button className="btn-delete" onClick={() => onDelete()}><span>삭제</span></button>
              <button className="btn-send" onClick={() => onInboxSubmit()} style={{display: true ? 'block' : 'none' }}><span>제출</span></button>
              {/* <button className="btn-send" onClick={() => onInboxSubmit()} style={{...isEndBtnShow===true?'':{display:"none"}}}><span>안 읽음</span></button> */}
              <button className="btn-send" onClick={() => onReceive()} style={{display: true ? 'block' : 'none' }}><span>수취완료</span></button>
              {/* <button className="btn-send" onClick={() => onReceive()} style={{...isSendBtnShow===true?'':{display:"none"}}}><span>읽음</span></button> */}
              <button className="btn-return" onClick={() => onReject()} style={{display: true ? 'block' : 'none' }}><span>반려</span></button> {/* DEV 비활성화 필요시: dis */}
          </div>
       </div>
      </div>
      {/* end of Edit Option */}

      <div className="service-table pop-over index-list" style={{marginBottom:"0rem"}}>
        <div className="header">
          <ul>
            {/*
                정렬 화살표를 출력하려면 sorting 클래스를 추가합니다.
                기본은 내림차순입니다. 오름차순으로 변경하려면 asc 클래스를 추가해줍니다.
            */}
            <li className="col code" >선택</li>
            <li className="col title sorting" onClick={(e) => {
              e.preventDefault();
              onSelected(e, 'order', 'DOCID');
            }} id="" >증명서/발급번호</li>
            {/* 신청자칼럼 삭제 : 임시
            <li className="col name sorting is-hidden" onclick="sortTable(0)" id="" >발급신청자</li>
             */}
            <li className="col company sorting is-hidden" onClick={(e) => {
              e.preventDefault();
              onSelected(e, 'order', 'SUBMISSION');
            }} id="" >상호</li>
            <li className="col company sorting is-hidden" onClick={(e) => {
              e.preventDefault();
              onSelected(e, 'order', 'SUBMISSION');
            }} id="" >제출처</li>
            <li className="col date2 sorting is-hidden" onClick={(e) => {
              e.preventDefault();
              onSelected(e, 'order', 'ISSUEDT');
            }} id="" >발급일시</li>
            <li className="col date sorting is-hidden" onClick={(e) => {
              e.preventDefault();
              onSelected(e, 'order', 'MOD_DT');
            }} id="" >최종이력</li>
            <li className="col status sorting is-hidden" onClick={(e) => {
              e.preventDefault();
              onSelected(e, 'order', 'STS');
            }} id="" >상태</li>
            <li className="col attach-pdf" id="" >첨부</li>
          </ul>
        </div>

        <div className="service-table-scroll">
          <div className="inner">
            <div className="scroll">
              {
                props.data?.length > 0 ?
                   props.data?.map((contract, index) => (
                    <div key={index} className="row "> {/* DEV 선택시 클래스추가: selected */}
                      {/* 체크박스로 대체 : 06.23
                        <input title="목록선택" type="radio" id={`${"row-" + contract.crtSeq + index}`} name="row-popover" onClick={(e) => onToggle(e)} />
                      */}
                        <div className="check">
                          <input type="checkbox" className="in_ch" id={`${"row-" + contract.crtSeq + index}`}
                                 onChange={(e) => checkHandler(e, contract)}
                                //  checked={checkedItems.has(contract.crtSeq)?true:false}
                                 checked={checkedContactsRef.current.has(contract)}
                          />
                          <label htmlFor={`${"row-" + contract.crtSeq + index}`} >
                            {contract?.crtCd === '01' ?
                            <span className="code" data-title="선택">
                              선택
                            </span>
                            :
                            <span className="code t2" data-title="간접수출 실적 증명서" >
                              간접
                            </span>
                            }
                             
                           </label>
                        </div>

                        <Link to="#" title="상세화면" className="detail-cont" role="button" onClick={(e) => {
                          if(e.target.getAttribute('name') === 'pdf-down' || e.target.closest('li').getAttribute('name') === 'pdf-down')  {
                            e.preventDefault()
                            console.log(contract.fileList)
                            
                            onPdfDown(contract)                            
                            return
                          }
                          props.onInboxDetail(contract);
                        }} >
                            <ul>
                              <li className="col code is-hidden"></li>
                              <li className="col title">
                              	<b>
                                {contract?.crtCd==='01'?'구매확인서':'간접수출증명서'}
                                 {/*<i class="badge_new">N</i> 20210713 : NEW추가 */}                                
                                </b>
                                <div className="table-cell">
                                    <span data-title="발급번호">
                                        {contract.docid}
                                    </span>
                                    <span className="is-show right" data-title="최종이력">
                                      {moment(contract.modDt).format('YYYY.MM.DD')}
                                    </span>
                                </div>
                                <div className="is-show table-cell">
                                  <span data-title="공급자상호" className="company">
                                    {contract?.prchsNm}
                                  </span>
                                  <span className="right" data-title="상태">
                                    {makeStatusBtn(contract?.sts)}
                                  </span>
                                </div>
                              </li>
                              {/* 신청자칼럼 삭제 : 임시
                              <li className="col name is-hidden">
                                {contract?.regUser}
                              </li>
                              */}

                              <li className="col company is-hidden">
                                {contract?.prchsNm}
                                {contract?.sender && <span data-title="보낸사람"><br/>➥{contract?.sender}</span>}
                              </li>
                              <li className="col company is-hidden">
                                {contract?.crtCd === '01' ?'-': contract?.submission}
                              </li>
                              <li className="col date2 is-hidden">
                                {
                                  moment(contract?.issuedt, 'YYYYMMDDHHmmss').format('YYYY.MM.DD HH:mm:ss')
                                } 
                              </li>
                              <li className="col date is-hidden">
                                {moment(contract?.modDt).format('YYYY.MM.DD HH:mm:ss')}
                              </li>
                              <li className="col status is-hidden">
                                {makeStatusBtn(contract?.sts)}
                              </li>
                              <li className="col attach-pdf" name="pdf-down" title="pdf 다운">
                                <img src="../images/icon-pdf-down-new.png"/>
                              </li>
                            </ul>
                        </Link>

                      {/* 삭제영역 */}
                      <div className="row-popover">
                        <div className="row-popover-content dis-flex">
                          <button className="btn btn-popover btn-dark-blue" onClick={() => props.onInboxDetail(contract)}>
                            선택
                          </button>
                          {
                            (contract?.sts === "01" || contract?.sts === "03" || contract?.sts === "04" || contract?.sts === "12") &&
                            <button className="btn btn-popover btn-white" onClick={() => onDelete(contract)}>
                              삭제
                            </button>
                          }
                          {
                            contract?.sts === "03" &&
                            <>
                              <button className="btn btn-popover btn-blue" onClick={() => props.onInboxSubmit(contract)}>
                                증명서 제출
                              </button>
                              {/*<button className="btn btn-md btn-red btn-h-turquoise">*/}
                              {/*  진위검증*/}
                              {/*</button>*/}
                            </>
                          }
                          {
                            (contract?.sts === "10" || contract?.sts === "12") &&
                            <button className="btn btn-popover btn-purple" onClick={() => onReject(contract)}>
                              반려
                            </button>
                          }
                        </div>
                      </div>
                    </div>

                  ))
                :  <div className="noData">조회 결과가 없습니다.</div>
              }
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

const mapStateToProps = state => {
  return {
    inboxInfo: state.inbox?.inboxInfo,
    isDelete: state.inbox?.isDelete,
    isDelete2: state.contracter?.isDelete,
    isReject: state.inbox?.isReject,
    isSubmit: state.inbox?.isSubmit,
    isReceive: state.inbox?.isReceive,
  }
}

const actionCreators = {
  getInboxInfo: inboxActions.getInboxInfo,
  changeSearchInfo: inboxActions.changeSearchInfo,
  deleteInbox: inboxActions.deleteInboxList,
  rejectInbox: inboxActions.rejectInbox,
  readInboxList: inboxActions.readInboxList,
  receiveInbox: inboxActions.receiveInbox,
  deleteTempDoc : contracterActions.deleteTempDoc,
  success: alertActions.success,
  confirm: alertActions.confirm,

  showModalBagic: modalActions.showModalBagic,
  clearModal:modalActions.clearModal
}

export default connect(
  mapStateToProps,
  actionCreators
)(CertificateInboxList)
